import { BookOpen } from '@icon-park/react';
import { Fragment, memo } from 'react';
import { FormattedMessage } from 'react-intl';

import type { LearningResource } from '@didaskill/domain/learning-resources/types';
import { EmptyState, ImpulseSpinner, InfiniteScroll } from '@didaskill/ui/design-system';

import messages from './LearningResourcesList.messages';
import * as styles from './LearningResourcesList.styles';

type LearningResourcesListProps = {
  learningResources: LearningResource[];
  children: React.ReactNode;
  isLoading?: boolean;
  isFetchingNextPage?: boolean;
  hasNextPage?: boolean;
  fetchNextPage?: () => void;
  scrollParentRef?: React.RefObject<HTMLDivElement>;
};

export const LearningResourcesListBase = ({
  learningResources,
  isLoading,
  isFetchingNextPage,
  hasNextPage,
  fetchNextPage,
  scrollParentRef,
  children,
}: LearningResourcesListProps) => {
  if (isLoading) {
    return (
      <div css={styles.loader}>
        <ImpulseSpinner />
      </div>
    );
  }

  return (
    <Fragment>
      {(learningResources || []).length ? (
        <div css={styles.list}>
          <InfiniteScroll
            isFetchingNextPage={isFetchingNextPage}
            hasNextPage={hasNextPage}
            onLoadMore={fetchNextPage}
            root={scrollParentRef}
          >
            {children}
          </InfiniteScroll>
        </div>
      ) : (
        <div css={styles.emptyStateContainer}>
          <EmptyState
            icon={<BookOpen />}
            title={<FormattedMessage {...messages.EMPTY_STATE_RESOURCES_TITLE} />}
            size={EmptyState.SIZES.SMALL}
          />
        </div>
      )}
    </Fragment>
  );
};

LearningResourcesListBase.displayName = 'LearningResourcesList';

export const LearningResourcesList = memo(LearningResourcesListBase);
